import ActiveRecordResource from './ActiveRecordResource';
import config from 'config';
import {LiveImage, LiveImageDTO} from "./image";

export class PlayerPhotoImageDTO extends LiveImageDTO {
  medium: string;
  constructor(data) {
    super(data);
    this.medium = data.medium;
  }
}

export class PlayerPhotoImage extends LiveImage {
  protected _medium: string;

  get medium(): string {
    return this.isSaved ? this._medium : this.url;
  }

  constructor(data: PlayerPhotoImageDTO) {
    super(data);
    this._medium = data.medium;
  }

  get preview(): string {
    return this.medium;
  }
}

export interface PlayerDTO {
  id?: string;
  club_id: string;
  name: string;
  number: number;
  photo?: PlayerPhotoImageDTO;
  file?: Blob;
  age?: number;
  nationality?: string;
  position?: string;
  foot?: string;
  birthday?: number;
  place_of_birth?: string;
}

export interface PlayerFormDTO {
  id: string;
  club_id: string;
  name: string;
  number: number;
  photo?: PlayerPhotoImageDTO;
  file?: Blob;
  age?: number;
  nationality?: string;
  position?: string;
  foot?: string;
  birthday?: number;
  place_of_birth?: string;
}

/**
 * @property string position
 */
export default class Player extends ActiveRecordResource {
  public id: string;
  public club_id: string;
  public name: string;
  public number: number;
  public photo: PlayerPhotoImage;
  public position: string;
  public nationality: string;
  public foot: string;
  public birthday: Date;
  public age: number;
  public placeOfBirth: string;

  static path = `${config.backOfficeBasePath}/players`;

  static validateConstraints = {
    name: {
      presence: true,
      format: {
        pattern: "^[a-zA-Z]+(([',. -][a-zA-Z ])?[a-zA-Z]*)*$",
        message: "^Please, enter valid data"
      }
    },
    number: {
      presence: true,
      numericality: {
        onlyInteger: true,
        lessThanOrEqualTo: 99,
        greaterThan: 0,
        message: '^Value is not a number'
      }
    },
    file: {
      presence: {message: '^Please upload an image'}
    }
  };

  static mapRecords(data) {
    return data.map((item) => new Player(item));
  }

  prepareForSave(dataForSave): PlayerDTO {
    let {
      name,
      file,
      number,
      club_id,
      age,
      nationality,
      position,
      foot,
      birthday,
      placeOfBirth
    } = dataForSave;

    let data: PlayerDTO = {
      name,
      number,
      club_id,
      age,
      nationality,
      position,
      foot,
      birthday: birthday instanceof Date ? birthday.getTime() : undefined,
      place_of_birth: placeOfBirth
    };

    if (file && file instanceof LiveImage) {
      data.file = file.file;
    }

    return data;
  }

  get role(): string {
    return this.position;
  }

  get originalPhoto(): string {
    return this.photo !== undefined ? this.photo.url : undefined;
  }

  get mediumPhoto(): string {
    return this.photo !== undefined ? this.photo.medium : undefined;
  }

  _parseData(data: PlayerDTO) {
    let player: any = {};

    if (data.birthday) {
      player.birthday = new Date(data.birthday);
      delete data.birthday;
    }

    if (data.place_of_birth) {
      player.placeOfBirth = data.place_of_birth;
      delete data.place_of_birth;
    }

    if (data.photo) {
      player.photo = new PlayerPhotoImage(new PlayerPhotoImageDTO(data.photo));
      delete data.photo;
    }

    return Object.assign(player, data);
  }
}





// WEBPACK FOOTER //
// ./src/api/player.ts